module.exports = __webpack_public_path__ + "res/ic_winners.3ab4c7d76d4c0d5a6d48d0fac7ed0f2a.png";